__turbopack_context__.v({
  "chartBlock": "gp7Kxa_chartBlock",
  "charts": "gp7Kxa_charts",
  "control": "gp7Kxa_control",
  "controlLabel": "gp7Kxa_controlLabel",
  "controlRow": "gp7Kxa_controlRow",
  "explorer": "gp7Kxa_explorer",
  "left": "gp7Kxa_left",
  "missing": "gp7Kxa_missing",
  "missingBody": "gp7Kxa_missingBody",
  "paper": "gp7Kxa_paper",
  "paperMeta": "gp7Kxa_paperMeta",
  "paperTitle": "gp7Kxa_paperTitle",
  "range": "gp7Kxa_range",
  "readout": "gp7Kxa_readout",
  "readoutNum": "gp7Kxa_readoutNum",
  "replay": "gp7Kxa_replay",
  "step": "gp7Kxa_step",
  "stepNum": "gp7Kxa_stepNum",
  "steps": "gp7Kxa_steps",
  "tech": "gp7Kxa_tech",
});
